import { ReminderTrialEnd } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/ReminderSubscriptionEndBanner/ReminderTrialEnd';
import { ReminderCancellationPlan } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/ReminderSubscriptionEndBanner/ReminderCancellationPlan';

export function ReminderSubscriptionEndBanner() {
    return (
        <>
            <ReminderTrialEnd />
            <ReminderCancellationPlan />
        </>
    );
}
